import { createContext, useContext, ReactNode } from 'react'
import { useGetMe } from '@/services/queries/user/use-get-me'
import { IUserMe } from '@/types/user'
import { useAppSelector } from '@/redux/hooks'

interface IUserContext {
  user: IUserMe | undefined
  isLoading: boolean
  isError: boolean
}

const UserContext = createContext<IUserContext | null>(null)

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const isAuthenticated = useAppSelector((state) => state.user.isAuthenticated)
  const { data: user, isLoading, isError } = useGetMe(isAuthenticated)

  return (
    <UserContext.Provider value={{ user, isLoading, isError }}>
      {children}
    </UserContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useUser = (): IUserContext => {
  const context = useContext(UserContext)
  if (!context) {
    throw new Error('useUser must be used within a UserProvider')
  }
  return context
}
